import CustomersEntity from './CustomersEntity';

export default CustomersEntity;
